import { useMemo } from 'react';
import { useGetIndividualCompQuery, useGetGolfEventSummaryQuery } from '../state/api';
import { selectAllEvents } from '../state/entitySelectors';
import IndividualCompDetails from './individual-comp-details';
import { useAppSelector } from '../hooks/reduxHooks';

interface IndividualCompDetailsContainerProps {
  compID: string | undefined;
}

const IndividualCompDetailsContainer = ({ compID }: IndividualCompDetailsContainerProps) => {
  const { data: individualComp } = useGetIndividualCompQuery(compID!, {
    skip: compID === undefined,
  });

  // Fetch events with RTK Query
  useGetGolfEventSummaryQuery();

  // Use entity selector for optimized access to normalized data
  const events = useAppSelector(selectAllEvents);

  const eventSummary = useMemo(() => events.find((event) => event.indCompID === compID), [events, compID]);

  const merged = useMemo(() => {
    if (individualComp && eventSummary) {
      return { ...individualComp, venueName: eventSummary.venueName };
    }
    return individualComp ? { ...individualComp, venueName: '' } : undefined;
  }, [individualComp, eventSummary]);

  return <IndividualCompDetails individualComp={merged} />;
};

export default IndividualCompDetailsContainer;
